export default "__VITE_ASSET__BcfCcEbj__"